import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Select, MenuItem, InputLabel, FormControl, Alert, Box } from '@mui/material';
import { AdSpacePaymentDetailsInterface } from '../../../interfaces/interfaces';

interface Props {
  open: boolean;
  paymentToUpdate: AdSpacePaymentDetailsInterface | null;
  setPaymentToUpdate: React.Dispatch<React.SetStateAction<AdSpacePaymentDetailsInterface | null>>;
  onClose: () => void;
  onSave: () => void;
  updateError?: string | null;
}

export const PaymentDetailsUpdateDialog: React.FC<Props> = ({
  open,
  paymentToUpdate,
  setPaymentToUpdate,
  onClose,
  onSave,
  updateError,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>Update Payment Details</DialogTitle>
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
      {updateError && <Alert severity="error">{updateError}</Alert>}
      
      <TextField
        label="User ID"
        type="number"
        value={paymentToUpdate?.userId ?? ''}
        onChange={e => setPaymentToUpdate(p => p ? { ...p, userId: Number(e.target.value) } : p)}
        fullWidth
        margin="dense"
        required
      />
      
      <TextField
        label="Stripe Payment Intent ID"
        value={paymentToUpdate?.stripePaymentIntentId ?? ''}
        onChange={e => setPaymentToUpdate(p => p ? { ...p, stripePaymentIntentId: e.target.value } : p)}
        fullWidth
        margin="dense"
      />
      
      <TextField
        label="Stripe Session ID"
        value={paymentToUpdate?.stripeSessionId ?? ''}
        onChange={e => setPaymentToUpdate(p => p ? { ...p, stripeSessionId: e.target.value } : p)}
        fullWidth
        margin="dense"
      />
      
      <TextField
        label="Amount Paid (in cents)"
        type="number"
        value={paymentToUpdate?.stripeAmountPaid ?? ''}
        onChange={e => setPaymentToUpdate(p => p ? { ...p, stripeAmountPaid: Number(e.target.value) } : p)}
        fullWidth
        margin="dense"
        helperText="Amount in cents (e.g., 10000 = $100.00)"
      />
      
      <FormControl fullWidth margin="dense">
        <InputLabel id="status-label">Status</InputLabel>
        <Select
          labelId="status-label"
          value={paymentToUpdate?.status ?? 'pending'}
          label="Status"
          onChange={e => setPaymentToUpdate(p => p ? { ...p, status: e.target.value } : p)}
        >
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="paid">Paid</MenuItem>
          <MenuItem value="failed">Failed</MenuItem>
        </Select>
      </FormControl>
      
      <TextField
        label="Completed At"
        type="datetime-local"
        value={paymentToUpdate?.completedAt ? new Date(paymentToUpdate.completedAt).toISOString().slice(0, 16) : ''}
        onChange={e => setPaymentToUpdate(p => p ? { ...p, completedAt: new Date(e.target.value) } : p)}
        fullWidth
        margin="dense"
        InputLabelProps={{ shrink: true }}
      />

      <Box sx={{ mt: 1 }}>
        <Alert severity="info">
          Cart details are stored as JSON and can be viewed but not edited here for safety.
          Use database tools for direct cart data modifications.
        </Alert>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button color="primary" onClick={onSave} variant="contained">Save Changes</Button>
    </DialogActions>
  </Dialog>
);
